<div
  [placement]="'top-right auto'"
  [ngbTooltip]="tooltipText"
  [tooltipClass]="'ngb-boels-tooltip'"
  [autoClose]="false"
  container="body"
  data-boundary="viewport"
  tabindex="0"
  role="button"
>
  <img
    class="eco-thumbnail"
    loading="lazy"
    src="assets/images/icons/product/symbols/symbol_16.png"
    [alt]="alt"
  />
</div>
